<template>
  <v-flex xs12>
    <v-title>Company Registration</v-title>
    <v-card>
      <v-layout row wrap class="ma-1">
        <v-flex xs6 class="px-1">
          <ValidationProvider
            v-slot="{ errors }"
            name="registeredCompanyName"
            rules="required"
          >
            <v-text-field
              v-model="editableDealerManager.registeredCompanyName"
              label="Registered Company Name"
              :error-messages="errors"
              data-vv-name="registeredCompanyName"
              required
            ></v-text-field>
          </ValidationProvider>
        </v-flex>
        <v-flex xs6 class="px-1">
          <ValidationProvider
            v-slot="{ errors }"
            name="tradingName"
            rules="required"
          >
            <v-text-field
              v-model="editableDealerManager.tradingName"
              label="Trading Name"
              :error-messages="errors"
              data-vv-name="tradingName"
              required
            ></v-text-field>
          </ValidationProvider>
        </v-flex>
        <v-flex xs4 class="px-1">
          <ValidationProvider v-slot="{ errors }" name="abn" rules="required">
            <v-text-field
              v-model="editableDealerManager.abn"
              label="ABN"
              :error-messages="errors"
              data-vv-name="abn"
              required
            ></v-text-field>
          </ValidationProvider>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>
<script>
export default {
  name: 'edit-company-details',
  props: {
    dealerManager: {
      type: Object,
      required: true,
    },
  },
  computed: {
    editableDealerManager: {
      get() {
        return this.dealerManager;
      },
      set(val) {
        this.$emit('update:dealerManager', val);
      },
    },
  },
};
</script>
